// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import AppVue from './App';
import '@/css/app.css';
import $Api from '@/utils/api.js';
import myhttp from '@/utils/myhttp.js';
import router from './router/router.js';
Vue.config.productionTip = false;

import "babel-polyfill"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI); //使用 ElementUI 框架

// import QuillEditor from 'vue-quill-editor'//npm install vue-quill-editor --save

// import 'quill/dist/quill.core.css'

// import 'quill/dist/quill.bubble.css'

// import 'quill/dist/quill.snow.css'

// Vue.use(QuillEditor)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import myUpload from './components/myUpload/my-upload.vue';
Vue.component('myUpload', myUpload)
import cEcharts from './components/circleEcherts/circleEcherts.vue';
Vue.component('cEcharts', cEcharts)
import cEchartsu from './components/circleEcherts/circleEchertsu.vue';
Vue.component('cEchartsu', cEchartsu)
//cnpm install @jiaminghi/data-view
//cnpm install chart.js
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
// import superEditor from '@/components/$Tinymce'
// console.error(superEditor)
// import mymenu from "@/components/$MyMenu";
// const mymenu = require( './components/$MyMenu.vue' ).default;
// Vue.use({ install(Vue){Vue.component('mymenu',mymenu)}}); //使用 Tibymce 富文本编辑器

/* 引入 vue-quill-editor + 百度 富文本编辑器 *
import echarts from 'echarts'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);
// Vue.prototype.$echarts = echarts;
/* *************************************** */

/* 👇 调试期间 👇 */
const error = console.error, reg = /Avoid mutating a prop|but referenced during render/;
console.error = function(vuewarn){
  // console.log(arguments);
  if( typeof vuewarn === 'string' && reg.test(vuewarn) ) return;
  return error(...arguments);
};
/* 👆 调试期间 👆 */

var tmp;
const W = window, $Vue = ( W.Vue = Vue ).prototype, hideProperty = A.hideProperty, Observable = Vue.observable;
/* 在这里自定义Vue的全局绑定公用变量(每个Vue页面都有绑定该变量) */
const $Global = $Vue.$Global = {
  __proto__: null,
  loading: '',
  currentPage: 1, // 当前是第几页
  pageSize: 10, // 当前页显示多少条数据
  sizeCount: 0, // 数据库总共多少条数据
  pageSizeList: [ 10, 20, 50, 100, 200, 500, 3000 ], // 分页组件的pageSize条目菜单
  // defaultKeys: [],
  // tableData: [],
  /* 👇 以下是我已经默认定义的变量, 可以直接使用, 不用再声明了
    W: W.innerWidth,  // window窗口的宽度(resize实时变化)
    H: W.innerHeight, // window窗口的高度(resize实时变化)
    dataReady: false, // 首次初始化加载数据接口是否完成
    currentFn: false, // 当前页面的Vue运行或者响应的接口函数对象
    text: '',         // 文本
    inputText: '',    // 输入的文本
    actived: '',      // 被激活的
    temp: '',         // 临时变量temp
    temp2: '',        // 临时变量temp2
    string: '',       // 字符串(空)
    string2: ' ',     // 字符串(空格)
    number: 0,        // 数字(0)
    number2: 1,       // 数字(1)
    boolean: false,   // 布尔值(false)
    boolean2: true,   // 布尔值(true)
    array: [],        // 空数组(array)
    array2: [],       // 空数组(array2)
    object: {},       // 空对象(object)
    object2: { currentPage: this.currentPage, pageSize: this.pageSize }, // 简单的分页对象 => 可复用myClone(object2)
  /* 👆 以下是我已经默认定义的变量, 可以直接使用, 不用再声明了 */
};
!$Global.pageSizeList.includes($Global.pageSize) && ( $Global.pageSize = $Global.pageSizeList[0] );
View.Vue && View.Vue(Vue); //挂载全局方法


/* 在这里修改全局的网页标题  */
const $Title = W.$Title = A.local('$projectName') || '训战管理平台';

/*
  在这里修改全局的默认主题颜色
    1) 紫罗兰 rgba(74, 9, 63, 1) rgba(103, 19, 89, 1) rgba(116, 22, 101, 1)
    2) 暗红色darkred: rgba(139, 0, 0, 1)
    3) 饿了么ElementUI默认的蓝色: rgba(64, 158, 255, 1)
*/
W.$Themecolor = Vue.Defaultcolor = A.local( '$Themecolor' ) || 'rgba(139,0,0,1)';


/* 在这里修改全局loading遮罩层 $Loading('正在上传..',temp1.el,'rgba(0, 0, 0, 0.5)') */
W.$Loaded = ()=>$loader$ && $loader$.close(); let $loader$ = 0;
W.$Loading = (text='正在加载..',target=null,background='rgba(255, 255, 255, 0.24)')=>{ // .el-loading-mask-dark
  // console.error(text[0] !== '#');
  background === 'dark' && ( background = '.el-loading-mask-dark' );
  target && (
    $loader$ && $loader$.parentElement === target
    ? $loader$.close()
    : ( target.lastElementChild || 0 ).classList.contains('el-loading-mask') && ( target.lastElementChild.outerHTML = '' )
  );
  target = $loader$ = $Vue.$loading({
    lock: text[0] !== '#',
    text: text[0] === '#' ? text.slice(1) : text,
    spinner: '',
    background: background[0] !== '.' ? background : '',
    target: target
  });
  background[0] === '.' && ( target.$el.classList.add(background.slice(1)) );
  return target;
};

const noop = ()=>{};
const DatetimePicker = (picker)=>{
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
  picker.$emit('pick', [start, end]);
};

const $forArr = forArr, $forObj = forObj, $mapArr = mapArr, $return = Return, $With = With;
/* 在这里自定义Vue的原型上面的方法或属性 */
$Vue.with({
  $Case: Case,
  $timer: Timer,
  $clone: myClone,
  $with(obj,value){ return arguments.length === 1 ? $With(this,obj) : $With(this,myClone(obj,value));   },
  $$formLabelWidth: '100px',
  $$headerStyle: {
    background: ($('html').$css('--Tablebg',"#d4d4d4"),'#d4d4d4'),
    color: "#333333"
  },
  $$pickerOptions: {
    shortcuts: [
      { text: '最近一周'  , onClick: DatetimePicker }, // 7
      { text: '最近一个月', onClick: DatetimePicker }, // 30
      { text: '最近三个月', onClick: DatetimePicker }, // 90
    ]
  },
  $$themeobj: {
    __proto__: null,

    success: '#67c23a',
       warn: '#e6a23c',
     danger: '#f56c6c',
  'danger+': '#F13400',
       info: '#909399',

  },

  $$setIndex(id,index) {
    var currentPage, pageSize; //$lastResponse = this.$lastResponse;
    // console.error(arguments.length);
    // console.errsor(this);
    if( arguments.length < 2 ){
      index = id, currentPage = this.currentPage, this.pageSize = this.pageSize
    }else {
      // console.warn(id + '_data');
      if ( ! ( id = this[ id + '_data'] ) ) return index + 1;
      currentPage = id.currentPage || 1;
      pageSize    = id.pageSize || 20;
    };
    // arguments.length < 2
    // ? ( index = id, currentPage = this.currentPage, this.pageSize = this.pageSize )
    // : ( currentPage = ( id = this[ id + '_data'] ) && id.currentPage || 1, pageSize = id && id.pageSize || 20  );
    return (( currentPage || 1) - 1) * pageSize + index + 1;
  },

  $nextTick2: async function(fn,...data){
    typeof fn === 'string' && ( fn = this[fn] );
    if( typeof fn !== 'function' ) return null;
    const res = await this.$nextTick(fn.bind(this,...data));
    return res;
  },

  $_Setapidata( api, bool ) {
    let apis,apirule, apidata =  api + '_data';
    if( ( apis = this[ apidata ] ) && apis.__ob__ && bool !== true ) return apis;
    const data = ( apirule = Apis[ api ] )
      ? apirule.slice(1).reduce( (a,v) => {
          a[ v ] = '';
          return a;
        }, apis||{} )
      : apis || {};
    return this[ apidata ] = bool ? W.$_Setapidata(data) : Observable( data );
  },

  /*$genFormrule([
      'name  !姓名 | 请填写姓名...',
      'email ?邮箱',
      'age   ?年龄'
    ])
    => { name: [ { "姓名不能为空..." } ], email: ··· }
  */
  $genFormrule: W.$genFormrule = (requireds)=>{
    return $return(requireds,(ruleobj,keyword,explain,msg,placeholder,required,temp)=>{
      ( required = ( temp = keyword.indexOf('!') ) !== -1 )
      ? [ explain, msg, placeholder ] = keyword.slice(temp+1).split('|')
      : (
        temp = keyword.indexOf('?'),
        [ explain, placeholder ] = keyword.slice(temp+1).split('|')
      );
      keyword = keyword.slice(0,temp).trim();

      if( required )
        required = explain || '该值', msg = msg||(required+"不能为空!");
      required = ruleobj[ keyword ] = required ? [
        { required: true, message: msg, trigger: "blur"},
        { required: true, message: msg, trigger: "change" },
        { required: true, message: msg, trigger: "submit" },
      ] : [];
      required.label = explain;
      required.placeholder = placeholder;
    },{__proto__: null});
  },

  _log(){ console.log(...arguments);return arguments[arguments.length-1];},
  _warn(){ console.warn(...arguments);return arguments[arguments.length-1];},
  _error(){ error(...arguments);return arguments[arguments.length-1];},

  _confirm(msg,call,tip) {
    // alert(msg);
    var $ = ()=>{};
    const confirm = async () => {
      // console.error($);
      // const promise = new Promise(suc=>$=suc);
      var _res;
      this.$confirm(msg, tip||'提示', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        // callback(action){action === 'confirm' && (typeof call === 'string' ? this[call] : call )();}
      })
      .then(v=>{
        (typeof call === 'string' ? this[call] : (call||noop) ).call(this);
        _res(true);
        $(true);
        // console.warn(res,[res],res.thenCall);
        // res.thenCall && res.thenCall.call(this,true);
        // res.finallyCall && res.finallyCall.call(this,true);
      })
      .catch(err=>{
        self._nextick.length = 0;
        _res(false);
        $(false);
      });
      //.finally(e=>console.error(111,e));
      _res = await new Promise(suc=>_res=suc);
      // console.error(11111, _res);
      // await sleep(3000);
      // console.error(res);
      _res !== true && ( self._nextick.length = 0 );
      return _res === true ? true : false;
      // console.warn(res,self._nextick);
      // return false;
    };

    const res = new Promise(suc=>$=suc);
    res.with({
      // then: call=>(res.thenCall=call,res),
      // catch: call=>(res.catchCall=call,res),
      // finally: call=>(res.finallyCall=call,res),
      trigger: (...args)=>{
        // res.thenCall = $=>self.trigger(...args);
        self.trigger(...args);
        // console.warn( args );
        return self;
      }
    });

    const self = this.$trigger(confirm);
    // console.error([self]);
    // console.error([ self ]);
    // res._isVue = true, res.$this = this;
    // res.__proto__.__proto__ = W.$_Prototrigger;
    return res;
  },

});

// console.error('menu...');
/* 在这里管理全局右侧菜单栏 */
const Menus = W.$Menus;
const Actived = Menus.actived = {
  __proto__: null,
  opened: [],
  // 设置 激活的菜单索引index
  index: '',
  // 设置 头部的高度
  minHeaderHeight: tmp = ( W.innerHeight - 679 ) / 44.67 + 48, headerHeight: A.local('$Headerheight') * 1 || tmp,
  // 设置 菜单是否折叠
  collapseWidth: Menus.collapseWidth = 50, collapse: tmp = A.local('$RightMenuNavCollapsed') === 'false' ? false : true,
  // 设置 菜单宽度 width
  defaultWidth: Menus.defaultWidth = 199, width: ( tmp ? Menus.collapseWidth : Menus.defaultWidth ) + 'px',
  set headers( app ) {
    Actived.$unwatchHeaders && Actived.$unwatchHeaders();
    Actived.$unwatchHeaders = app.$watch('actived.headerHeight',height=>{
      // console.error(bool);
      A.local('$Headerheight',height);
    });
  },
  set navs( navs ) {
    // console.error(self);
    Actived.$unwatchNavs && Actived.$unwatchNavs();
    Actived.$unwatchNavs = navs.$watch('actived.collapse',bool=>{
      // console.error(bool);
      A.local('$RightMenuNavCollapsed',bool);
    });
  }
};
let Englishmenus = Menus.Englishmenus; Menus.updateEn = ()=>Englishmenus = Menus.Englishmenus;
const Apis = W.Apis = $Vue.Apis = Menus.Apis;
W.$Api = $Api;

// console.log(22222222);
const ZhuboMenus = /*Menus.ZhuboMenus =*/ (ishow=true)=>{
  // console.error( ishow, Local(loginTypeword), 111 );
  // ishow = true;
  if( ishow === 0 ) { // 初始化刷新浏览器的时候强制进行一次登录判断检查
    ishow = Local(loginTypeword) === loginTypeZhubo;
  }else {
    ishow === true ? Local(loginTypeword,loginTypeZhubo) : clearLocal(loginTypeword);
  };

  Actived.initIndex = null;

  // ishow = true;

  forLoop( Menus, menu=>{
    // console.error( menu, 11111111 );
    if( menu.show === 0 ) return;
    menu.show = menu.type === '老师'  || menu.parent.type === '老师'
      ? (
          // console.error( 1, menu.actived, Actived.index, menu.url ),
          ishow && menu.actived && ( Actived.initIndex = menu.url ),
          // console.error( 2, menu.actived, Actived.index, menu.url, Actived ),
          // menu.defaultOpened = ishow
          // console.error(menu, ishow, menu.routeMeta),
          menu.routeMeta && ( menu.routeMeta.notrouter = ishow === false ),
          ishow
      )
      // : true;
      : ( menu.routeMeta && ( menu.routeMeta.notrouter = ishow === true ), !ishow );

  }, 'submenus' );

  return Actived.initIndex;
};

/* 这里是全局判断监听Vue路由的钩子函数, 可以写自己的逻辑... */
let Appload = W.Appload = false;
const loginTypeZhubo = A.loginTypeZhubo = '2';
const loginTypeword = A.loginTypeword = '$Usertype';
const ifExistLogin = A.ifExistLogin = '$Userid'; // !! 在这里设置根据缓存哪个字段来判断是否退出到登录页 !!
const $Newrouter = W.$Newrouter, $Routers = W.$Routers, META = $Routers.$metas, Local = A.local, clearLocal = A.clearLocal;
const $Routerpaths = W.$Routerpaths;
// console.error(Vue.parseApi);
const Englishpaths = hideProperty( Menus, 'Englishpaths', { __proto__: null } );
(Vue.parseRouter = ()=>{
  // console.error($Routers);
  const hide = A.hideProperty;
  Return( $Routers, (a,v,n)=>{
    // console.error(v.name, Englishmenus[v.name]);
    // console.error(v, v.name, Englishmenus[v.name]);
    n = ( a[ n = v.name ] = v ).ismenu = Englishpaths[v.fpath] = Englishmenus[ n ];
    // console.warn(v.fpath, n);
    // console.warn(n, v.name, v, Englishpaths, Englishmenus);
    if( null != n ) hide(n,'routeMeta',v.meta), n.fpath = v.fpath;
  }, W.$Routernames || ( W.$Routernames = { __proto__: null } ) );
  return;
})();

/* *********** 👇 路由配置 👇 ************* */
/*const 路由参考配置 = {
   rootpage:      '整个项目的根页面, 比如 /login (:又比如 https://www.baidu.com/)',

   homepage:      '整个项目的主页-首页, 比如 /home(:或者/index等等)',

   refreshtoroot: '当重新刷新浏览器的时候, 是否跳转到根页面(:比如/login)',

   refreshtohome: '当重新刷新浏览器的时候, 是否跳转到首页面(:比如/home)',

   notkeepalive:  '该页面不要缓存数据和状态, 路由改变则立即销毁(:全局默认采用的是keepalive)',

   fullscreen:    '该页面是否为满屏, 即占据整个window窗口(:此时会隐藏菜单栏+导航栏,例如/login页面)',

   closemenu:     '该页面是否收起侧边的菜单栏(:例如/home等不在菜单中显示但是会在router路由中显示的页面)',

   collapsemenu:  '该页面是否(收起+折叠)侧边的菜单栏(:例如你想让这个页面有更大尺寸的显示效果时)',

   'toggle+上面的配置': '第一次进来的时候设置该属性,下次进来的时候取消该属性,再下一次往复循环...',

   'once+上面的配置':   '只在第一次进来的时候设置该属性,设置完之后立即取消',

   ":备注:": `
      👆 以上这些配置都可以在 /src/views/*.vue 的文件路径里面配置 👇
                    比如现在项目里面有这些文件:
        /home.Homepage.Closemenu.vue   -> 首页 + 关闭菜单
        /login.Rootpage.fullscreen.vue -> 根页面(登录页) + 独立的全屏显示
      👆                                                          👆
   `
 };*/
/* *********** 👆 路由配置 👆 ************* */
W.onhashchange = event=>{
  var hash = W.location.hash;
  ( event = $Routers[hash=hash.replace('#/','/')] ) && !event.meta.notrouter
  ? $Newrouter.push(hash)
  : ( sleep.clear(0.0000404), W.history.go(-1) );
  // console.error(hash,event,!event.meta.notrouter);
};

Menus.forLoop = function(menus,force){
  this.length = 0;
  forLoop(menus,(v,k,i,p)=>{
    // console.error(v);
    switch( v.authType ) {
      case '2': return;
      case '0':
        v.submenus = v.children;
        if( (v.authUrl||(v.authUrl=''))[0] !== '#' ) { v.show = true; break; };
        // console.error(v.children,v.authUrl);
        v.show = v.authUrl !== '#' ? ( v.authUrl = v.authUrl.substring(1), true ) : 0, v.submenus = null;
      case '1':
        ( v.children || [] ).reduce( (a,v)=>(
          a[v.authRemark] = ( v.authUrl = (v.authUrl||'').trimLeft() )[0] === '/' ? [
              v.authUrl + ' | 正在' + v.authName + '..',
              ...(v.authParams||'').split('\n').filter(v=>v.trim())
          ] : v.authUrl,
          a
        ), v.api || ( v.api = {__proto__:null} ) );
        v.children = null, typeof p === 'object' && p !== null && ( p.children = null );
        break;
    };
    v.name = v.authName;
    v.url = v.authUrl;
    v.icon = v.authIcon;
    return;
  });
  if( menus === true ) return this.parse(), Vue.parseApi(true);
  // console.warn(force);
  return this.push(...menus||[]), this.parse(), Vue.parseApi(force?true:false);
};
A.doLogin = (title='训战管理平台')=>{
  App.Gohomepage(NaN), App.isLogin = true;
  A.local( '$projectName', document.title = W.$Title = title );
  if( A.local('$RightMenuNavCollapsed') ) {
    alertSuccess('登录成功！<br> 提示: 可以点击左上角的logo区域切换折叠右边侧边栏!', 1000, '登录成功');
  } else {
    let events;
    let alert = alertSuccess('登录成功！<br> 提示: 可以点击左上角的logo区域切换折叠右边侧边栏!', 0, '登录成功');
    ( events = W.$Events ).RightMenuNavCollapsed = [
      bool=>{
        alert.close();
        A.local('$RightMenuNavCollapsed',"false");
        delete events.RightMenuNavCollapsed;
        // console.error('delete删除了....',A.local('$RightMenuNavCollapsed'));
        return true;
      }
    ];
    alert.onClick = ()=>alert.close();
    alert.ResetRun('onClose',()=>{
      alertSuccess.vue = false;
      A.local('$RightMenuNavCollapsed','true');
    });
    // document.addEventListener( 'mousedown', iknown = ()=>{
    //   alert('message?: DOMString');
    //   alert.close(document.removeEventListener('click', iknown, true));
    // }, true );
  };
};
A.relogin = async ()=>{
  /*const Parseword = (str)=>{
    const info = { account: '', password: '' };
    info.account = unescape(str||'').replace(/₯(.+)₰/,(a,b)=>{
      info.password = b[0] + b.slice(2);
      return "";
    });
    return info;
  };Parseword(A.local('$Loginfo')) */
  const loading = $Loading();
  const res = await Vue.prototype.$post.call( {object2: {}}, $Api.getUserOperation, null, '正在加载...' ); // {projectId:+A.local('$projectId')}
  loading.close();
  if( res && res.isuccess ) {
    const Userinfo = res.data.data || {};
    A.local('$Userinfo',JSON.stringify(Userinfo)), A.local("$Username",Userinfo.userName || "?");
    Menus.forLoop(Userinfo.roleAuthListSort, true);
    initLogin = null;
    return true;
  };
};
var initLogin = Local(ifExistLogin) ? A.relogin : null;

$Newrouter.beforeEach( async (to, from, next) => {
    if( null !== initLogin && ( to.path !== '/login' ? true !== await initLogin() : initLogin = null ) ) return;

    const islogin = Local(ifExistLogin);
    let fromMeta = from.meta, toMeta = to.meta, toggle, toggleProp, tmp, isRelogin = false;
    // console.warn( '上一个路由信息::', fromMeta, from, AllPageapidata );
    // console.warn( '当前路由信息::',   toMeta,   to, to.query   );
    // console.error(to.meta.gorootpage && !Appload, to.meta.gorootpage, Appload, W.Appload);
    /* !! 根据是否缓存有指定字段来判断是否退出到登录页 !! */
    /* meta.rootpage to.query.preview */
    if(!from.name) for( tmp in to.query ) {
      // console.error(tmp, from, to);
      fromMeta.oncegorootpage = true;
      break;
      // $Newrouter.replace({ path: META.homepage });
      // return;
    };
    // console.warn(from, to, W.location.href);
    if( !to.name /* !!路由名字不存在 */
        || fromMeta.oncegorootpage && (  fromMeta.oncegorootpage = false, true ) /* !!路由请求退出 */
        // || toMeta.notrouter /* !!路由属性是 notrouter 即是普通的vue页面, 不要把它当作路由来处理 */
        || toMeta.refreshtoroot && !Appload /* !!路由属性是 refreshtoroot 且当前浏览器正在刷新 */
        || !islogin && !toMeta.rootpage /* !!新手上路 本地还从没有登陆过该网站 to.path !== META.rootpage*/
      ) {
      // console.error(1111111, from, to, META.rootpage);
      return $Newrouter.replace({ path: islogin ? from.path || META.homepage : META.rootpage });
    };

    // console.error(to.path);
    // Menus.ZhuboMenus = to.path === '/login' ? ZhuboMenus : null;

    for( toggleProp in toggle = fromMeta.toggle ) {
      if( ( tmp = fromMeta[ toggleProp ] ) === tmp )
        fromMeta[ toggleProp ] = tmp ? '' : toggle[ toggleProp ];
    };
    fromMeta.loaded++;

    toMeta.from = fromMeta;

    // console.error(toMeta.fpath, AllPagecache[toMeta.fpath]);
    if(
      ( tmp = fromMeta.returnrefresh )
      && fromMeta.oncereturnrefresh === fromMeta.oncereturnrefresh
      && ( fromMeta.returnrefresh = fromMeta.oncereturnrefresh = false, Vue.nextTick(()=>fromMeta.returnrefresh = tmp||true), true )
      || fromMeta.oncereturnrefresh && ( fromMeta.oncereturnrefresh = false, true )
    ) {
      console.error('静态刷新...');
      Root.$push(to,'refresh');
    }else {

      // console.log('该路由成立!!',to,AllPagecache);
      if( toMeta.rootpage ) {
        // console.error(AllPagecache);
        for( tmp in AllPagecache ) AllPagecache[tmp] = false;
        Root.$trigger && Root.$trigger('*exitlogin');
      }else isRelogin = AllPagecache[toMeta.fpath] === false && ( AllPagecache[toMeta.fpath] = true );

      if( toggle = toMeta.toggle ) {
        if( toMeta.loaded )
          for( toggleProp in toggle ) {
            toMeta[ toggleProp ] = toMeta[ toggleProp ] ? '' : toggle[ toggleProp ];
          };
      };
      toMeta.loaded++;

    };

    // $Routerpaths[ meta.fpath ]
    if( toMeta.closemenu || toMeta.onceclosemenu && ( toMeta.onceclosemenu = false, true ) ) {

      // console.error(Root.App,meta.closemenu);
      Root.App && Root.App.closemenu();

    } else if( to = Englishmenus[ to.path ] || Englishmenus[ to.name ] ) {

      // console.warn(155555, to, to.index, to.router );
      ( toMeta.ismenu = to ).index
      ? Vue.nextTick(v=>Actived.index=to.index)
      : !Actived.initIndex && ( Actived.initIndex = to.name );
    };

    // console.warn(1111111111, to, from, AllPagecache );
    if( isRelogin  ) {
      console.error('重新登录之后刷新...');
      Root.$push(to,'refresh');
      return;
    };

    if( toMeta.notrouter ) {
      console.warn('路由属于notrouter');
      sleep(0.0000404,next);
      return false;
    };

    // console.warn($Routerpaths[toMeta.fpath],toMeta);
    if( !toMeta.ismenu && $Routerpaths[toMeta.fpath].ismenu && !toMeta.homepage && !toMeta.rootpage ) {
      // console.error(toMeta);
      return $Newrouter.replace({ path: META.homepage });
    };
    // await sleep(15000);
    // console.error(Root,Appload);
    next();

});

const setMenutoVue = { __proto__: null };
// const Apidatas = {
//   __proto__: null,
//   get currentPage(){ return $Global.currentPage; },
//   get pageSize(){ return $Global.pageSize; },
//   // $$lastres:    {},
//   // $$lastparams: {}
// };
var $test = 0;
const AllPageapidata = { __proto__: null }, AllPagecache = W.AllPagecache = { __proto__: null };
// console.error(AllPageapidata);
/* 这里是全局判断监听Vue初始化data(){}的钩子函数, 可以自定义页面data */
$Newrouter.dataHook = (thisvue,ismenu,meta)=>{
  if( !( meta = thisvue.$meta ) || !(ismenu = meta.ismenu ) ) {
    // console.error(thisvue.$$path, AllPageapidata, meta);
    // console.error( thisvue.$options.__file, Englishmenus[ thisvue.$options.__file ] );
    return ( ismenu = thisvue.$options.__file ) &&  AllPageapidata[ ismenu ]; // ( ismenu = Englishmenus[ ismenu ] ) && ismenu.$apidata;
  };

  let Apiparams = Englishmenus[ ismenu.url ], id;
  // console.warn( ismenu.url, Apiparams );
  /*if( Apiparams ) {
    const id = thisvue._uid, $this = Apiparams.$this;
    ( $this[0] = $this[ id ] = thisvue ).myBind('_isDeactived',is=>is && delete $this[id]);
    thisvue.$destroyed.push( f=>{ delete $this[id] });
  };*/

  // console.error(meta.fpath);
  AllPagecache[meta.fpath] = true;
  let path, apidata = AllPageapidata[ path = thisvue.$options.__file || meta.fpath || ismenu.routePath  ];
  if( apidata ) {
    // console.error( AllPageapidata, path );
    Apiparams = apidata.Apiparams, delete apidata.Apiparams;
    $forObj( apidata, (v,k,k2)=>{
      $forObj( v, (v2,k2)=>{
        v[k2] = '';
      } );
      v.currentPage = $Global.currentPage;
      v.pageSize = $Global.pageSize;
      // v.$$row = 0;
      // v.$$col = 0;
      v.$$lastres = {};
      v.$$lastparams = {};
    } );
    apidata.Apiparams = Apiparams;
    return thisvue.$options.__proto__.apidata = apidata;
  };

  return thisvue.$options.__proto__.apidata = AllPageapidata[ path ] = ( forObj( ismenu.api, (v,apiname)=>{

        typeof v !== 'object' && ( v = [ v ] );

        const eachdata = thisvue[ apiname + '_data' ] = {  };
        // console.error( apiname );
        $forArr(v.slice(1),key=>eachdata[key] = Apiparams[key] = '');
        eachdata.currentPage = $Global.currentPage;
        eachdata.pageSize    = $Global.pageSize;
        // eachdata.$$row = 0;
        // eachdata.$$col = 0;
        eachdata.hideProperty('$$lastres',{});
        eachdata.hideProperty('$$lastparams',{});

        Apiparams.hideProperty( '$rule_' + apiname, v.$rule );

      },thisvue = { __proto__: null, Apiparams: ( Apiparams = {} ).hideProperty( '$rule', ismenu.$rule ) } ), thisvue );
  // if( $Routers[ thisvue.$$path ] === $Routerpaths[ thisvue.$$path ] )
  // console.error(thisvue.$meta);
};


/*
  Vue.mixin({
    data() {
      // console.error(this);
      return {
        isShowing: false
      }
    },
    mounted() {
      // console.log('hello from mixin!');
      // console.error(this);
    },
    method:{
      test:function(){
      }
    }
  });
*/
/*
Vue.component('mytemplate2',Vue.extend({
  data(){
      return {
          msg:'我是标题^^'
      };
  },
  template:'<h3>{{ (_error(_self),msg) }}</h3>'
}));*/

Vue.component('mytemplate', {
  props: [ 'template', 'row', 'context', 'data' ],

  data(){
    return this.data || { xxx: 8888888 };
  },

  render(h,tmp) {
    tmp = typeof this.template === 'string' ? this.template : '';
    if( tmp === '' ) return;
    const mytemplate = Vue.extend({
        template: tmp,
        props: [ 'template', 'row', 'context' ]
    });
    const host = this.$vnode.context
    const context = typeof this.context === 'string' ? host.$refs[ this.context ] = this : this.context || host, row = this.row||{};
    // console.error(this,this.$vnode.context,tmp);
    tmp = h(mytemplate, {
        props: [ 'template', 'row', 'context' ]
    });
    tmp.$context = context, tmp.$row = row;

    !context.hasOwnProperty('$row') && ( context.$row = row );
    tmp.$proxy = new Proxy(context,{
      get: (obj,prop)=>{
        // console.warn('getter:',prop, context[ prop ], this);
        // console.error(this);
        // if( !componentContext._isMounted ) return
        return prop === '$row' ? ( context.$row = row ) : typeof ( prop = context[ prop ] ) === 'function' ? prop.bind(context) : prop;
      },
      set(obj,prop,value){
        // console.error('setter:',prop, context[ prop ], value);
        context[ prop ] = value;
        return true;
      },
      // apply()
    });

    return tmp;
  }
});
// console.error(mytemplate);

// console.warn('new Vue...');
// ZhuboMenus(0);
/* eslint-disable no-new */
let Root = 0;
Root = W.Root = new Vue({
  el: '#app',
  data: { App: 0 },
  router,
  // data: { activeDate: 1 },
  // template: '<router-view x:key=activeDate />',
  components: { AppVue },
  template: '<AppVue ref=App />',
  mounted(){ this.App = this.$refs.App; Appload = Appload || true; },
});



// WEBPACK FOOTER //
// ./src/main.js